// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"247":"Recommendations-RecommendationsContainer","873":"SavedSearch-Container-SavedSearchesContainer"}[chunkId] + "-" + {"247":"d2588ddbfc0dd9c09ddc","873":"b1be4619c9344180d1a6"}[chunkId] + ".css";
};